/**
 * Maps a control's outer size to the appropriate inner icon/spinner size.
 * @internal — Spellbook-only
 */
export function getControlIconSize(controlSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | null): 'xs' | 'sm' | 'md' {
  if (controlSize === 'lg' || controlSize === 'xl' || controlSize === '2xl') return 'md';
  if (controlSize === 'xs') return 'xs';
  return 'sm';
}

/**
 * Maps a control's outer size to the appropriate inner text variant.
 * @internal — Spellbook-only
 */
export function getControlTextVariant(controlSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | null): 'label-3' | 'label-1' {
  if (controlSize === 'xs' || controlSize === 'sm') return 'label-3';
  return 'label-1';
}

/**
 * Same mapping as `getControlTextVariant`, for the Button/ToggleButton/FilterChipToggle/ToggleGroup
 * family specifically: their scale has both `xs` and `sm` tiers, and `xs` (not `sm`) is the compact
 * one, so `sm` joins `md`/`lg` at `label-1` here — unlike `getControlTextVariant`, which stays `xs`
 * unchanged for controls (e.g. `Tabs`) whose scale has no `xs` tier and treats `sm` as the compact one.
 * @internal — Spellbook-only
 */
export function getButtonTextVariant(controlSize?: 'xs' | 'sm' | 'md' | 'lg' | null): 'label-3' | 'label-1' {
  return controlSize === 'xs' ? 'label-3' : 'label-1';
}
